import { render, staticRenderFns } from "./aiXSAnalysis.vue?vue&type=template&id=28db5b4e&scoped=true"
import script from "./aiXSAnalysis.vue?vue&type=script&lang=js"
export * from "./aiXSAnalysis.vue?vue&type=script&lang=js"
import style0 from "./aiXSAnalysis.vue?vue&type=style&index=0&id=28db5b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28db5b4e",
  null
  
)

export default component.exports